import React from 'react';
import { 
  Backdrop,
  CircularProgress
} from '@mui/material';

/**
 * Simple Loading Overlay Component
 * Shows a clean loading spinner
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the loading overlay is open
 */
const LoadingOverlay = ({ open }) => {
  return (
    <Backdrop
      sx={{
        color: '#1976d2',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(4px)'
      }}
      open={open}
    >
      <CircularProgress 
        size={40} 
        thickness={4}
        sx={{
          color: '#1976d2'
        }}
      />
    </Backdrop>
  );
};

export default LoadingOverlay;